import React, { useState } from 'react';
import { Clock } from 'lucide-react';
import { cases } from '../data/mock';
import { trackCtaClick } from '../utils/analytics';

const Cases = () => {
  const [filter, setFilter] = useState('todos');

  const types = ['todos', ...new Set(cases.map(c => c.type))];
  
  const filteredCases = filter === 'todos' 
    ? cases 
    : cases.filter(c => c.type === filter);

  const handleCaseContact = (ctaText) => {
    const message = encodeURIComponent(`Olá! Gostaria de conversar sobre: ${ctaText}`);
    const whatsappUrl = `https://wa.me/5511984845464?text=${message}`;
    trackCtaClick({ cta: 'whatsapp', location: 'contact', url: whatsappUrl });
    window.open(whatsappUrl, '_blank');
  };

  return (
    <section id="casos" className="section-padding">
      <div className="container-custom">
        <h2 className="section-title">Casos e iniciativas</h2>
        
        <div className="projects-filter">
          {types.map((type) => (
            <button
              key={type}
              onClick={() => setFilter(type)}
              className={`filter-btn ${filter === type ? 'active' : ''}`}
            >
              {type.charAt(0).toUpperCase() + type.slice(1)}
            </button>
          ))}
        </div>

        <div className="projects-grid">
          {filteredCases.map((caseItem) => (
            <div key={caseItem.id} className="project-card">
              <div className="project-header">
                <span className="project-type">{caseItem.type}</span>
                {caseItem.status === 'em-andamento' && (
                  <span className="project-status">
                    <Clock size={16} />
                    Em andamento
                  </span>
                )}
              </div>
              
              <h3 className="project-name">{caseItem.name}</h3>
              <p className="project-description">{caseItem.description}</p>
              
              <button 
                onClick={() => handleCaseContact(caseItem.ctaText)}
                className="project-link-button"
              >
                Quero algo parecido
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Cases;
